import Vue from 'vue'
import VueRouter from 'vue-router'
import axios from 'axios'

Vue.use(VueRouter)

const routes = [{
    path: '/',
    name: 'home',
    meta: {
        title: '国研网世界经济数据库系统'
    },
    component: () =>
        import ('@/views/home')
}, {
    path: '/list',
    name: 'list',
    meta: {
        title: '国研网世界经济数据库系统'
    },
    component: () =>
        import ('@/views/list')
}]

const router = new VueRouter({
    routes,
    mode: 'history',
    base: '/',
})

router.afterEach((to, from) => {
    try {
        if (LogCollection) {
            LogCollection.init();
            console.log(LogCollection.init());

        }
    } catch (error) {
        console.log(error);
    }
})
export default router